<script setup></script>

<template>
  <div class="login-page login-bg">
      <div class="login-box">
        <slot />
      </div>
  </div>
</template>

<style scoped>
.login-bg{
  background-image: url('@/assets/img/bg.jpg');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  background-attachment: fixed;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: alpha(opacity=0);
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
  animation-duration: 0.25s;
  animation-delay: 0.5s;
  animation-name: slidein;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
}
@keyframes slidein {
  from {
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    opacity: 0;
  }

  to {
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    filter: alpha(opacity=100);
    -moz-opacity: 1;
    -khtml-opacity: 1;
    opacity: 1;
  }
}
</style>